import React from 'react'
import './Checkout.css';
import CheckoutProduct from './CheckoutProduct';
import Subtotal from './Subtotal.js';
import {useStateValue} from "./StateProvider";
import { HelpOutline } from '@material-ui/icons';



function Checkout() {
                const [{basket,user}, dispatch]=useStateValue();


    return (
        <div className="checkout">
            <div className="checkout_left">
                <img className="checkout_ad" src="https://shoppingrechargeoffers.com/wp-content/uploads/2019/11/Amazon-Prime-Exclusive-Deals-Offers.jpg"alt="" />
            <div>
                <h3>Hello, {user?.email}</h3>
                <h2 className="checkout_title">Your Shopping Cart</h2>
                {basket.map(item=>(
                    <CheckoutProduct
                    title={item.title}
                    image={item.image}
                    price={item.price}
                    rating={item.rating}/>



                ))}
            </div>
           
           </div>
            <div className="checkout_right">
                <Subtotal />
            </div>
            
        </div>
    )
}

export default Checkout
